<template>
	<div class="container">
		<div class="content">
			<div class="card mb_0">
				<div v-if="isShowList">
					<h3 class="title mb_20">
						{{ $t('merchant.transaction.text1') }}
					</h3>
					<div>
						<div class="calendar_area_box">
							<div class="info mb_8">
								<date-picker
									is-required
									v-model="startDate"
									:model-config="{ type: 'string' }"
									:locale="$store.state.common.locale"
									mode="dateTime"
									is24hr
								>
									<template v-slot="{ inputValue, inputEvents }">
										<label class="calendar_area">
											<input
												class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
												:value="inputValue"
												v-on="inputEvents"
											/>
										</label>
									</template>
								</date-picker>
							</div>
							<div class="info mb_8">
								<date-picker
									is-required
									v-model="endDate"
									:model-config="{ type: 'string' }"
									:locale="$store.state.common.locale"
									mode="dateTime"
									is24hr
								>
									<template v-slot="{ inputValue, inputEvents }">
										<label class="calendar_area">
											<input
												class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
												:value="inputValue"
												v-on="inputEvents"
											/>
										</label>
									</template>
								</date-picker>
							</div>
						</div>
						<div class="d_flex mb_16">
							<div class="info flex_grow3 search mr_8">
								<input
									type="text"
									:placeholder="$t('input.placeholder.search_activity')"
								/>
							</div>
							<button class="button_bg_black" @click="loadTransactionList">
								{{ $t('button.search') }}
							</button>
						</div>
						<div class="all_payment title_m">
							<p class="mb_8">
								{{ $t('merchant.transaction.total_count') }}
								{{ summary.count }}{{ $t('merchant.transaction.count') }}
							</p>
							<p>
								{{ $t('merchant.transaction.total_amount') }}
								{{ summary.sum }} JPYS
							</p>
						</div>
					</div>
					<div v-if="transactionList.length === 0" class="list_none">
						<span class="ERRORGRAY"></span>
						<p>{{ $t('merchant.transaction.empty') }}</p>
					</div>
					<div v-else class="list">
						<div
							class="list_wrap"
							v-for="item in transactionList"
							:key="item.seq"
							@click="showDetail(item)"
						>
							<span class="list_num_m">{{ item._no }}</span>
							<div>
								<span>{{ $t('merchant.transaction.table.time') }}</span>
								<span>{{
									$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss')
								}}</span>
							</div>
							<div>
								<span>{{ $t('merchant.transaction.table.name') }}</span>
								<span>{{ item.title }}</span>
							</div>
							<div>
								<span>{{ $t('merchant.transaction.table.id') }}</span>
								<span>{{ item.transaction_id }}</span>
							</div>
							<div>
								<span>{{ $t('merchant.transaction.table.payer') }}</span>
								<span>{{ item.payer_name }}</span>
							</div>
							<div>
								<span>{{ $t('merchant.transaction.table.amount') }}</span>
								<span>{{ item.amount + ' ' + item.asset_code }}</span>
							</div>
							<div>
								<span>{{ $t('merchant.transaction.table.type') }}</span>
								<span>{{ item.transaction_type }}</span>
							</div>
							<div class="mb_0">
								<span>{{ $t('merchant.transaction.table.status') }}</span>
								<span>{{ item.status }}</span>
							</div>
						</div>
					</div>
					<pagination
						v-if="transactionList.length !== 0"
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
				<div v-if="!isShowList" class="transaction_detail">
					<div class="d_flex align_items_center mb_16" @click="back">
						<span class="LEFTARROW mr_8"></span>
						<h3 class="title_s">{{ $t('merchant.transaction.text4') }}</h3>
					</div>
					<div class="information">
						<div>
							<span>{{ $t('merchant.transaction.table.order_no') }}</span>
							<span>{{ transactionInfo.order_id }}</span>
						</div>
						<div>
							<span>{{ $t('merchant.transaction.table.name') }}</span>
							<span>{{ transactionInfo.title }}</span>
						</div>
						<div>
							<span>{{ $t('merchant.transaction.table.id') }}</span>
							<span>{{ transactionInfo.transaction_id }}</span>
						</div>
						<div>
							<span>{{ $t('merchant.transaction.table.payer') }}</span>
							<span>{{ transactionInfo.payer_name }}</span>
						</div>
						<div>
							<span>{{ $t('merchant.transaction.table.amount') }}</span>
							<span>{{
								transactionInfo.amount + ' ' + transactionInfo.asset_code
							}}</span>
						</div>
						<div>
							<span>{{ $t('merchant.transaction.table.status') }}</span>
							<span>{{ transactionInfo.status }}</span>
						</div>
						<div class="mb_0">
							<span>{{ $t('merchant.transaction.table.time') }}</span>
							<span>{{
								$dayjs(transactionInfo.regdate).format('YYYY.MM.DD HH:mm:ss')
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from '@/components/Pagination';
import { commonError } from '@/common/dialog';
import { fetchMerchantTransactionList } from '@/api/merchant';
import { mapGetters } from 'vuex';
import '@/assets/css/merchant.m.css';
export default {
	name: 'TransactionList.m',
	components: {
		pagination,
	},
	data() {
		return {
			transactionList: [],
			isShowList: true,
			startDate: this.$dayjs(new Date())
				.add(-6, 'month')
				.startOf('day')
				.toDate(),
			endDate: this.$dayjs(new Date()).endOf('day').toDate(),
			transactionInfo: {},
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			summary: {
				count: 0,
				sum: 0,
			},
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
	},
	created() {
		this.init();
	},
	methods: {
		back() {
			this.isShowList = true;
		},
		init() {
			Promise.all([this.loadTransactionList()]);
		},
		async loadTransactionList() {
			let regdate_start = '',
				regdate_end = '';
			if (this.startDate) {
				regdate_start = new Date(this.startDate).getTime();
			}
			if (this.endDate) {
				regdate_end = new Date(this.endDate).getTime();
			}

			const { data, page_navigation } = await fetchMerchantTransactionList({
				...this.$route.query,
				...this.$route.params,
				regdate_start: regdate_start,
				regdate_end: regdate_end,
				page: this.curPage,
				list_count: this.listCount,
			}).catch(commonError);

			this.transactionList = data;
			this.pageNavigation = page_navigation;
			this.getSummary();
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadTransactionList();
		},
		getSummary() {
			let sum = 0;
			this.transactionList.forEach(item => {
				sum += item.amount * 1;
			});
			this.summary.count = this.transactionList.length;
			this.summary.sum = sum;
		},
		showDetail(transactionInfo) {
			this.transactionInfo = transactionInfo;
			this.isShowList = false;
		},
	},
};
</script>
